// extracted by mini-css-extract-plugin
module.exports = {"button":"PdfButton_button__4Csrl","disabled":"PdfButton_disabled__3UGIZ"};